import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Displays date or time.", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Date and Time Formatting", -1)
const _hoisted_6 = { class: "date-formatting col" }
const _hoisted_7 = { class: "date-formatting col" }
const _hoisted_8 = { class: "date-formatting col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.contentName), 1),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_form_item, {
          prop: "day",
          label: "Show Day of the Week"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "mt-1",
              modelValue: _ctx.content.showDay,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content.showDay) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_form_item, {
          prop: "date",
          label: "Show Date"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "mt-1",
              modelValue: _ctx.content.showDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content.showDate) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.content.showDate)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              prop: "dateFormat",
              label: "Date Format"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "Select date format",
                  modelValue: _ctx.content.dateFormat,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.content.dateFormat) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _ctx.longDataLabel,
                      value: "long"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.shortDataLabel,
                      value: "short"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_form_item, {
          prop: "time",
          label: "Show Time"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "mt-1",
              modelValue: _ctx.content.showTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.content.showTime) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.content.showTime)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              prop: "timeFormat",
              label: "Show 24 Hour"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  class: "mt-1",
                  modelValue: _ctx.content.timeFormat24,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.content.timeFormat24) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}